import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { SettingField } from './SettingField';
import type { SettingDto, SettingsByCategoryDto } from '../types/settings';

interface SettingsByCategoryProps {
  settings: SettingsByCategoryDto[];
  onSettingUpdated: (setting: SettingDto) => void;
}

/**
 * Component that renders settings grouped by category in cards
 */
export function SettingsByCategory({ settings, onSettingUpdated }: SettingsByCategoryProps) {
  if (settings.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No settings found
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {settings.map((categoryGroup) => (
        <Card key={categoryGroup.category}>
          <CardHeader className="pb-3">
            <CardTitle className="text-lg">{categoryGroup.category}</CardTitle>
          </CardHeader>
          <CardContent>
            {categoryGroup.settings.map((setting) => (
              <SettingField
                key={setting.key}
                setting={setting}
                onUpdated={onSettingUpdated}
              />
            ))}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
